module.exports = __webpack_public_path__ + "fa-brands-400.ttf?c5ebe0b32dc1b5cc449a76c4204d13bb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-brands-400.ttf
// module id = 39
// module chunks = 0